import {createApi, fetchBaseQuery} from "@reduxjs/toolkit/query/react";

import {rpWebUrl} from "../../../common/app/read_charts_web_environment_variables";

export interface IRpRegionListItem {
    id: number;
    slug: string;
    full_name_reverted?: string;
    short_name?: string;
    type?: number;
}

export interface IRpRegionMapSearchItem extends IRpRegionListItem {
    full_name_reverted: string;
    type: number;
}

interface IRpRegionListResponse {
    results?: IRpRegionListItem[];
}

export const rpRegionsApi = createApi({
    reducerPath: "rpRegionsApi",
    baseQuery: fetchBaseQuery({
        baseUrl: rpWebUrl
    }),
    endpoints: (builder) => ({
        getRegionList: builder.query<IRpRegionListItem[], {region?: number[]; parent?: number; page_size?: number}>({
            query: (params) => ({
                url: "/api/v2/regions/region/",
                params: {
                    s: "region-list",
                    page_size: 200,
                    ...params
                }
            }),
            transformResponse: (response: IRpRegionListResponse) => response.results ?? []
        }),
        getRegionBySlug: builder.query<IRpRegionListItem, string>({
            query: (slug) => ({
                url: "/api/v2/regions/region/",
                params: {
                    s: "region-list-map",
                    slug,
                    page_size: 1
                }
            }),
            transformResponse: (response: IRpRegionListResponse, _meta, slug) => {
                const region = response.results?.[0];
                if (!region) {
                    throw new Error(`Region not found for slug: ${slug}`);
                }
                return region;
            }
        }),
        searchMapRegions: builder.query<IRpRegionMapSearchItem[], {full_name: string}>({
            query: ({full_name}) => ({
                url: "/api/v2/regions/region/",
                params: {
                    s: "region-list-map",
                    full_name,
                    page_size: 30
                }
            }),
            transformResponse: (response: IRpRegionListResponse) => (response.results ?? []) as IRpRegionMapSearchItem[]
        })
    })
});

export const {useGetRegionListQuery, useGetRegionBySlugQuery, useSearchMapRegionsQuery} = rpRegionsApi;
